const imageFields = new Set(["image", "imageUrl", "images", "productImages"]);

const withoutImages = (value) => {
  if (Array.isArray(value)) return value.map(withoutImages);
  if (!value || typeof value !== "object") return value;
  return Object.fromEntries(
    Object.entries(value)
      .filter(([key]) => !imageFields.has(key))
      .map(([key, entry]) => [key, withoutImages(entry)]),
  );
};

export const buildVendorItemPayload = ({
  details,
  menuItemId,
  companyId,
  businessType,
  values,
  addonSectionIds,
  imageBase64,
  existingImageUrl,
  imageRemoved = false,
  hasImage = false,
}) => {
  const payload = {
    active: false,
    outOfStock: false,
    displayOrder: 0,
    portions: [],
    ...(imageBase64 || imageRemoved ? withoutImages(details || {}) : details || {}),
    ...values,
    companyId,
    currency: "USD",
    basePrice: values.priceUSD,
    addonSectionIds: businessType === "GROCERIES" ? null : addonSectionIds,
  };

  if (details) {
    payload.menuItemId = details.menuItemId || menuItemId;
  }
  if (imageBase64) {
    payload.imageUrl = imageBase64.replace(/^data:[^,]*,/, "");
  } else if (imageRemoved) {
    payload.imageUrl = "";
  } else if (details) {
    const existingImage = details.imageUrl ?? details.imageURL ?? existingImageUrl ?? "";
    payload.imageUrl = typeof existingImage === "string"
      ? existingImage.replace(/^data:[^,]*,/, "")
      : existingImage;
  }

  return payload;
};
